import React from "react";
import { Group, Select, Stack, Text, Button } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { DateRangeFilter as DateRangeFilterType } from "../utils/dateRangeUtils";

interface DateRangeFilterProps {
  value: DateRangeFilterType;
  onChange: (value: DateRangeFilterType) => void;
  customRange: [Date | null, Date | null];
  onCustomRangeChange: (range: [Date | null, Date | null]) => void;
  onApply?: () => void;
}

const dateOptions = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "this-week", label: "Week" },
  { value: "this-month", label: "Month" },
  { value: "custom", label: "Custom Date Range" },
];

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  value,
  onChange,
  customRange,
  onCustomRangeChange,
  onApply,
}) => (
  <Stack spacing="sm">
    <Select
      value={value}
      onChange={(val) => {
        if (val) onChange(val as DateRangeFilterType);
      }}
      data={dateOptions}
      size="sm"
      sx={{ minWidth: 180 }}
    />
    {value === "custom" && (
      <Group spacing="sm" align="flex-end">
        <Stack spacing={4}>
          <Text size="xs" weight={500}>
            From{" "}
            <Text component="span" color="red">
              *
            </Text>
          </Text>
          <DatePicker
            placeholder="Select"
            value={customRange[0]}
            onChange={(date) => {
              // Auto-adjust "To" date if "From" is after "To"
              if (date && customRange[1] && date > customRange[1]) {
                onCustomRangeChange([date, date]);
              } else {
                onCustomRangeChange([date, customRange[1]]);
              }
            }}
            maxDate={customRange[1] || undefined}
            size="sm"
            sx={{ minWidth: 160 }}
          />
        </Stack>
        <Stack spacing={4}>
          <Text size="xs" weight={500}>
            To{" "}
            <Text component="span" color="red">
              *
            </Text>
          </Text>
          <DatePicker
            placeholder="Select"
            value={customRange[1]}
            onChange={(date) => {
              // Auto-adjust "From" date if "To" is before "From"
              if (date && customRange[0] && date < customRange[0]) {
                onCustomRangeChange([date, date]);
              } else {
                onCustomRangeChange([customRange[0], date]);
              }
            }}
            minDate={customRange[0] || undefined}
            size="sm"
            sx={{ minWidth: 160 }}
          />
        </Stack>
        <Button
          size="sm"
          onClick={onApply}
          disabled={!customRange[0] || !customRange[1]}
          sx={{ alignSelf: "flex-end" }}
        >
          Apply
        </Button>
      </Group>
    )}
  </Stack>
);

export default DateRangeFilter;
